import classNames from 'classnames';
import type { ReactNode } from 'react';

export interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  action?: ReactNode;
  children?: ReactNode;
  iconRight?: ReactNode;
  selected?: boolean;
}

export const CardHeader = ({
  action,
  children,
  iconRight,
  selected,
  ...props
}: CardHeaderProps) => {
  return (
    <div
      className={classNames(
        'w-full h-ds-12.5 flex justify-between items-center gap-1.5 p-2.5 group-[.ds-not-hovered]:bg-ds-natural-50 group-[.ds-not-hovered]:rounded-md',
        selected &&
          'rounded-md outline outline-ds-primary-300 outline-offset-[-1px] bg-ds-natural-50'
      )}
      {...props}
    >
      <div className="flex-1 overflow-hidden whitespace-nowrap">{children}</div>
      {action}
      {iconRight}
    </div>
  );
};
